import { DevelopmentSummaryDetail } from 'components/hr-metrics/development-summary/DevelopmentSummaryDetail'
import { INITIAL_DATA_QUERY_DEVELOPMENT_SUMMARY_DETAIL } from 'configs/hr-metrics/configTableDevelopmentSummary'
import { ACTION_TYPE } from 'constants/constant'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import { API_DEVELOPMENT_SUMMARY } from 'services/apiDevelopmentSummary'
import { useFetch } from 'services/useFetch'
import { downloadFile, getAllQueryParams, setQueryParams } from 'utils/utils'

const OPTION_UPLOAD = {
    INDIVIDUAL_PERFORMANCE: 'individual_performance',
    APPRAISAL: 'appraisal',
}

const FILTER_PARAMS = [
    'department_ids',
    'division_ids',
    'three_sixty_categories',
    'performance_categories',
    'potential_categories',
    'nine_box_labels',
]

const DevelopmentSummaryDetailContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const periodId = searchParams.get('periodId')
    const [queryFilter, setQueryFilter] = useState()
    const query =
        searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_QUERY_DEVELOPMENT_SUMMARY_DETAIL
    const [selectedItem, setSelectedItem] = useState(null)
    const [isShowToast, setIsShowToast] = useState(false)
    const [toastMessage, setToastMessage] = useState('')
    const [selectedIds, setSelectedIds] = useState([])
    const [fileType, setFileType] = useState(null)
    const [modal, setModal] = useState({
        export: false,
        import: false,
        delete: false,
        limit: false,
        sync: false,
        upload: false,
        edit: false,
        view_document: false,
    })

    const {
        data: detailList,
        fetching: getDetail,
        isLoading,
    } = useFetch(
        { ...API_DEVELOPMENT_SUMMARY.DETAIL, initPathVariable: periodId },
        INITIAL_DATA_QUERY_DEVELOPMENT_SUMMARY_DETAIL,
    )
    const { fetching: exportDevelopmentSummary } = useFetch(API_DEVELOPMENT_SUMMARY.EXPORT)
    const { fetching: deleteDevelopmentSummary, isLoading: isDeleting } = useFetch(API_DEVELOPMENT_SUMMARY.DELETE)
    const { fetching: syncDevelopmentSummary, isLoading: isSyncing } = useFetch(API_DEVELOPMENT_SUMMARY.SYNC)

    useEffect(() => {
        getDetailList()
    }, [location?.search])

    const getDetailList = async () => {
        const newQuery = { ...query }
        const newQueryFilter = {}
        Object.entries(newQuery).forEach(([key, item]) => {
            if (FILTER_PARAMS.includes(key)) {
                const valueOfQuery = FILTER_PARAMS.includes(key) ? item.split(',') : item
                newQuery[key] = valueOfQuery
                newQueryFilter[key] = valueOfQuery
            }
        })
        setQueryFilter(newQueryFilter)
        getDetail(newQuery)
    }

    const setShowModal = (value) => {
        setModal({ ...modal, ...value })
    }

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const clearToast = () => {
        setIsShowToast(false)
        setToastMessage('')
    }

    const showToast = (message) => {
        setIsShowToast(true)
        setToastMessage(message)
    }

    const onClickItemHandler = ({ item, actionType }) => {
        switch (actionType) {
            case ACTION_TYPE.EDIT:
                setSelectedItem(item)
                setShowModal({ edit: true })
                break
            case ACTION_TYPE.DELETE:
                setSelectedItem(item)
                setShowModal({ delete: true })
                break
            case ACTION_TYPE.PREVIEW:
                setSelectedItem({
                    Individual_Performance: item?.individual_performance_file,
                    Appraisal: item?.appraisal_file,
                })
                setShowModal({ view_document: true })
                break
            default:
                break
        }
    }

    const onExportHandler = () => {
        const body = { ...query, ids: selectedIds.map((item) => item.id) }

        exportDevelopmentSummary(body, periodId, {}, 'blob').then((res) => {
            downloadFile(null, res, `Development-Summary-Export-${moment().format('DD-MM-YYYY')}.xlsx`)
            setShowModal({ export: false })
            showToast('Export Data Berhasil !!')
        })
    }

    const onDelete = () => {
        deleteDevelopmentSummary(null, selectedItem?.id).then(() => {
            setModal({ ...modal, delete: false })
            showToast('Data Berhasil Dihapus !!')
            getDetailList()
        })
    }

    const onSync = () => {
        syncDevelopmentSummary(null, periodId).then(() => {
            setModal({ ...modal, sync: false })
            showToast('Sync Data Berhasil !!')
            getDetailList()
        })
    }

    const onHideImport = (isComplete) => {
        setShowModal({ import: false })
        if (isComplete) {
            getDetailList()
        }
    }

    const onHideModal= (modalName) => {
        setShowModal({ [modalName]: false })
        setSelectedItem(null)
    }

    const onSelectUpload = (type) => {
        setFileType(type)
        setShowModal({ upload: true })
    }

    const onSuccess = (message) => {
        getDetailList()
        showToast(message)
    }

    const props = {
        dataList: detailList?.data,
        isLoading,
        isDeleting,
        isSyncing,
        query,
        queryFilter,
        toast: {
            isShowToast,
            message: toastMessage,
        },
        modal,
        selectedIds,
        optionUpload: OPTION_UPLOAD,
        fileType,
        selectedItem,
        setShowModal,
        setSelectedIds,
        clearToast,
        onChangeQuery,
        onClickItemHandler,
        onExportHandler,
        onDelete,
        onSync,
        onHideImport,
        onHideModal,
        onSelectUpload,
        onSuccess,
    }

    return <DevelopmentSummaryDetail {...props} />
}

export default DevelopmentSummaryDetailContainer
